import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'

export const Redirect = ({
  link,
  title,
  className,
  fitContent = false
}: {
  link: string
  title: string
  className: string
  fitContent?: boolean
}) => {
  const [isRelativeLink, setIsRelativeLink] = useState(false)

  useEffect(() => {
    setIsRelativeLink(
      !(link.indexOf('https://') === 0 || link.indexOf('http://') === 0)
    )
  }, [link])

  const parseLink = () => {
    if (isRelativeLink) {
      return (
        <Link className={className} to={link} style={fitContent ? { minWidth: 'fit-content', margin: 0, marginRight: '32px'
        } : {}}
>
          {title}
        </Link>
      )
    }

    return (
      <a
        className={className}
        href={link}
        target="_blank"
        rel="noopener nofollow"
        style={fitContent ? { minWidth: 'fit-content', margin: 0, marginRight: '32px'} : {}}
      >
        {title}
      </a>
    )
  }
  return parseLink()
}

export default Redirect
